import Nullstack from 'nullstack';
export default function IconCircleDotted({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-circle-dotted",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "7.5",
    y1: "4.21",
    x2: "7.5",
    y2: "4.22"
  }), "   ", Nullstack.element("line", {
    x1: "4.21",
    y1: "7.5",
    x2: "4.21",
    y2: "7.51"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "12",
    x2: "3",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "4.21",
    y1: "16.5",
    x2: "4.21",
    y2: "16.51"
  }), "   ", Nullstack.element("line", {
    x1: "7.5",
    y1: "19.79",
    x2: "7.5",
    y2: "19.8"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "21.01"
  }), "   ", Nullstack.element("line", {
    x1: "16.5",
    y1: "19.79",
    x2: "16.5",
    y2: "19.8"
  }), "   ", Nullstack.element("line", {
    x1: "19.79",
    y1: "16.5",
    x2: "19.79",
    y2: "16.51"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "12",
    x2: "21",
    y2: "12.01"
  }), "   ", Nullstack.element("line", {
    x1: "19.79",
    y1: "7.5",
    x2: "19.79",
    y2: "7.51"
  }), "   ", Nullstack.element("line", {
    x1: "16.5",
    y1: "4.21",
    x2: "16.5",
    y2: "4.22"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "3.01"
  }), " ");
}